/** Fields available on GET_MY_CARS_V2_LEAN rows (swap / earnings pickers). */
export type LeanCarLabelFields = {
  displayName?: string | null;
  year?: number | null;
  make?: string | null;
  model?: string | null;
};

/** Build year/make/model fallback when lean rows omit displayName (no legacy `name` field). */
export function formatLeanCarYmms(car: LeanCarLabelFields): string {
  return [car.year, car.make, car.model].filter(Boolean).join(' ').trim();
}

/** Primary label for lean picker cards — displayName, then Y/M/M, then generic fallback. */
export function formatLeanCarDisplayLabel(car: LeanCarLabelFields, fallback = 'Car'): string {
  const ymms = formatLeanCarYmms(car);
  return car.displayName?.trim() || ymms || fallback;
}

/** Exclude the booking's current car from swap picker options. */
export function filterSwapCandidateCars<T extends { id: string }>(
  cars: T[],
  currentCarId?: string | null,
): T[] {
  if (!currentCarId) return cars;
  return cars.filter(car => car.id !== currentCarId);
}
